import api from '@/api';
import { LOGIN, REFRESH_TOKEN } from '@/api/requests/auth/auth';
import ManuteAuthToken from '@/api/src/token';
import { AuthRequest } from '@/api/requests/auth/types';

export default class ManuteAuth {
    /**
     * Authenticate user.
     * @param credentials
     */
    static async authenticate(credentials: AuthRequest) {
        // Call API to refresh token.
        const response = await api.call(LOGIN(credentials));
        // Init token object
        const token = ManuteAuthToken.fromHttp(response.data);
        // Store the token in localstorage.
        token.toStorage();

        return token;
    }

    /**
     * Refresh auth token.
     */
    static async refreshToken() {
        // Get token from local storage
        const token = ManuteAuthToken.fromStorage();
        // Call API to refresh token
        const response = await api.call(REFRESH_TOKEN(token.refreshToken));
        // Init token object
        const refreshedToken = ManuteAuthToken.fromHttp(response.data);
        // Store the token in localstorage.
        refreshedToken.toStorage();

        return refreshedToken;
    }
}
